<template>
  <a-modal
    title="重置密码"
    style="top: 20px"
    :width="400"
    centered
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
  >
    <a-form :form="form">
      <a-form-item style="display: none">
        <a-input v-decorator="['userId']" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名">
        <a-input disabled v-decorator="['loginName', { rules: [{ required: true, message: '请输入用户名' }] }]" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新密码">
        <a-input
          type="password"
          v-decorator="['password', { rules: [{ validator: this.passText, required: true }] }]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { resetPwd } from '@/api/system'
import pick from 'lodash.pick'
export default {
  name: 'UserPwdModal',
  components: {},
  data() {
    return {
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      enterpriseId: '',
      userName: ''
    }
  },
  beforeCreate() {},
  created() {},
  methods: {
    //密码正则表达式
    passText(rule, value, callback) {
      // const pwdRegex =/^[a-zA-Z0-9_-]{6,20}$/
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else {
        callback()
      }
    },
    edit(record) {
      console.log(record)
      this.form.resetFields()
      if (record.enterpriseId && record.userName) {
        this.enterpriseId = record.enterpriseId
        this.userName = record.userName
      }
      this.mdl = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl, 'userId', 'loginName'))
        // this.form.setFieldsValue({ ...record })
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true
          values.enterpriseId = this.enterpriseId
          values.userName = this.userName
          resetPwd(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(`${values.loginName}` + '重置密码成功')
                // this.$emit('ok')
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
